import React from 'react';
import propTypes from './propTypes';

const MachineProductivity = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" y="15" width="11" height="4" fill="white" />
    <circle cx="5.5" cy="16.5" r="1.5" fill="currentColor" />
    <circle cx="12.5" cy="16.5" r="1.5" fill="currentColor" />
    <path d="M21.1639 3.27406C22.3042 4.51935 23 6.17842 23 8C23 9.0736 22.7583 10.0907 22.3264 11H9.67363C9.24169 10.0907 9 9.0736 9 8C9 4.13401 12.134 1 16 1C16.845 1 17.655 1.14973 18.405 1.4241L15.7277 3.00729C13.0929 3.14868 11 5.32992 11 8C11 8.3434 11.0343 8.67767 11.0996 9H20.9004C20.9657 8.67767 21 8.3434 21 8C21 6.92176 20.6587 5.92323 20.0782 5.10655L21.1639 3.27406Z" fill="currentColor" />
    <path d="M17.2028 7.01653L20.0658 2.1842L15.1969 5.06338C15.0547 5.14387 14.8921 5.23657 14.7625 5.36618C14.1767 5.95196 14.1767 6.90171 14.7625 7.4875C15.3483 8.07328 16.298 8.07328 16.8838 7.4875C17.0234 7.3479 17.109 7.17592 17.2028 7.01653Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17 12V22C17 22.5523 16.5523 23 16 23H14C13.4477 23 13 22.5523 13 22V21H5V22C5 22.5523 4.55228 23 4 23H2C1.44772 23 1 22.5523 1 22V5C1 3.34315 2.34315 2 4 2H9.9792C9.39315 2.58807 8.8927 3.26149 8.4981 4H4C3.44772 4 3 4.44772 3 5V7.16667L3.52472 6.42332C3.7121 6.15787 4.01676 6 4.34169 6H7.73663C7.58195 6.64138 7.5 7.31112 7.5 8H4.85984L3 10.6348V12H15H17ZM3 14H15V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V14Z" fill="currentColor" />
  </svg>
);

MachineProductivity.propTypes = propTypes;

export default MachineProductivity;
